// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Krona+One&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  position: fixed;
  z-index: 11;
  top: 0;
  left: 0;
  right: 0;
  padding: 1.95rem 0;
  background: linear-gradient(116.34deg, rgba(20, 21, 21, 0.2) -52.34%, rgba(42, 48, 70, 0.2) 94.28%);
  border-bottom: 0.1rem solid rgba(109, 138, 250, 0.1);
  transition: all linear 0.25s;
  -webkit-backdrop-filter: blur(12px);
          backdrop-filter: blur(12px);
}
@media (max-width: 767px) {
  .header {
    padding: 1.5rem 0;
    background-color: #000000;
  }
}
.header__scrolled {
  padding: 1.5rem 0;
  box-shadow: 0 1rem 1.4rem rgba(255, 255, 255, 0.06);
}
@media (max-width: 767px) {
  .header__scrolled {
    padding: 1rem 0;
  }
}
.header .container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header .custom-button {
  padding-top: 1.15rem;
  padding-bottom: 1.15rem;
}
@media (max-width: 767px) {
  .header .custom-button {
    padding: 0.8rem;
  }
}
.header .custom-button.outline-btn {
  padding-top: 1.05rem;
  padding-bottom: 1.05rem;
}
@media (max-width: 767px) {
  .header .custom-button.outline-btn {
    padding: 0.6rem;
  }
}
@media (max-width: 767px) {
  .header__logo img {
    max-width: 11rem;
  }
}
@media (max-width: 575px) {
  .header__logo img {
    max-width: 9rem;
  }
}
.header__actions {
  display: flex;
  gap: 2rem;
}
@media (max-width: 991px) {
  .header__actions {
    gap: 0.6rem;
  }
}
@media (max-width: 767px) {
  .header__actions .custom-button {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/UI/Header/Header.scss","webpack://./src/Assets/Theme/_var.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,mGAAA;EAKA,oDAAA;EACA,4BAAA;EACA,mCAAA;UAAA,2BAAA;AAJF;AAME;EAhBF;IAiBI,iBAAA;IACA,yBCdI;EDWN;AACF;AAME;EACE,iBAAA;EAEA,mDAAA;AALJ;AAOI;EALF;IAMI,eAAA;EAJJ;AACF;AAOE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AALJ;AAQE;EACE,oBAAA;EACA,uBAAA;AANJ;AAQI;EAJF;IAKI,eAAA;EALJ;AACF;AAOI;EACE,oBAAA;EACA,uBAAA;AALN;AAMM;EAHF;IAII,eAAA;EAHN;AACF;AAUM;EADF;IAEI,gBAAA;EAPN;AACF;AAQM;EAJF;IAKI,eAAA;EALN;AACF;AAYE;EACE,aAAA;EACA,SAAA;AAVJ;AAYI;EAJF;IAKI,WAAA;EATJ;AACF;AAYM;EADF;IAEI,gBAAA;IACA,mBAAA;IACA,uBAAA;EATN;AACF","sourcesContent":["@import \"../../../Assets/Theme/_var.scss\";\n\n.header {\n  position: fixed;\n  z-index: 11;\n  top: 0;\n  left: 0;\n  right: 0;\n  padding: 1.95rem 0;\n  background: linear-gradient(\n    116.34deg,\n    rgba(20, 21, 21, 0.2) -52.34%,\n    rgba(42, 48, 70, 0.2) 94.28%\n  );\n  border-bottom: 0.1rem solid rgba($primary, 0.1);\n  transition: all linear 0.25s;\n  backdrop-filter: blur(12px);\n \n  @media (max-width: 767px) {\n    padding: 1.5rem 0;\n    background-color: $black;\n    // top: 32px;\n  }\n\n  &__scrolled {\n    padding: 1.5rem 0;\n    // background: $black;\n    box-shadow: 0 1rem 1.4rem rgba(255, 255, 255, 0.06);\n\n    @media (max-width: 767px) {\n      padding: 1rem 0;\n    }\n  }\n\n  .container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .custom-button {\n    padding-top: 1.15rem;\n    padding-bottom: 1.15rem;\n\n    @media (max-width: 767px) {\n      padding: 0.8rem;\n    }\n\n    &.outline-btn {\n      padding-top: 1.05rem;\n      padding-bottom: 1.05rem;\n      @media (max-width: 767px) {\n        padding: 0.6rem;\n        // padding-bottom: 0.8rem;\n      }\n    }\n  }\n\n  &__logo {\n    img {\n      @media (max-width: 767px) {\n        max-width: 11rem;\n      }\n      @media (max-width: 575px) {\n        max-width: 9rem;\n      }\n    //   @media (max-width: 479px) {\n    //     max-width: 7.2rem;\n    //   }\n    }\n  }\n\n  &__actions {\n    display: flex;\n    gap: 2rem;\n\n    @media (max-width: 991px) {\n      gap: 0.6rem;\n    }\n\n    .custom-button {\n      @media (max-width: 767px) {\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n      }\n    }\n  }\n}\n","@import url(\"https://fonts.googleapis.com/css2?family=Krona+One&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\n$baseFont: \"Poppins\", sans-serif;\n$baseFont2: \"Krona One\", sans-serif;\n\n$white: #ffffff;\n$black: #000000;\n$primary: #6d8afa;\n$primary2: #6f86de;\n$lightGray: #bdbdbd;\n$lightGray2: #d1d1d1;\n$secondary: #252a3a;\n$secondary2: #232323;\n$secondary3: #a3a3a3;\n$secondary4: #727272;\n$secondary5: #292c2e;\n$secondarybg: #171b27;\n$secondarybg2: #22283a;\n$secondarybg3: #202535;\n$secondarybg4: #172545;\n$borderClr: #262626;\n$borderClr2: #252525;\n$borderClr3: #28343e;\n\n$green: #7bbb3f;\n$blue: #2797d1;\n$red: #c3292d;\n$orange: #f68630;\n$skyblue: #01cde4;\n$yellowdark: #fbbb10;\n$reddark: #e54c40;\n\n$btnGradient: linear-gradient(270deg, #fde679 -0.16%, #f26c33 86.5%);\n\n$gradient: linear-gradient(90.71deg, #6f86de -2.07%, #4b67d1 100%);\n$gradient2: linear-gradient(0deg, rgba(0, 0, 0, 0) -29.92%, #161616 97.38%);\n$gradient3: linear-gradient(90deg, #fde076 1.57%, rgba(242, 107, 51, 0) 101.1%);\n$gradient4: linear-gradient(261.01deg, #212122 2.84%, rgba(0, 0, 0, 0) 165.67%);\n\n$boxShadow: 0 1.2rem 1.6rem -0.4rem rgba(255, 255, 255, 0.2),\n  0 0.4rem 0.6rem -0.2rem rgba(255, 255, 255, 0.15);\n$boxShadow2: 0 1rem 1.4rem rgba(255, 255, 255, 0.06);\n$boxShadow3: inset 3px 17px 37px rgba(3, 3, 3, 0.6),\n  inset 0px 0px 5px rgba(255, 255, 255, 0.1);\n\n// z indexes\n$header: 988;\n$sidebar: $header + 3;\n$sidebar_overlay: $sidebar - 2;\n$modal: 1056;\n$loader: 1090;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
